import { useQuery } from "@tanstack/react-query";

import { listAttendanceDays } from "@/adapters/api";
import type { AttendanceWorkerDays } from "@/features/presence/types";
import { toAttendanceWorkerDays } from "@/features/presence/utils/map";
import { useActiveContext } from "@/store/use-active-context";
import { monthRange } from "../utils/format";

export function useWorkerMonthDays(
	workerId: string | undefined,
	month: string,
	enabled = true,
) {
	const activeCanteiroId = useActiveContext((state) => state.activeCanteiroId);
	const range = monthRange(month);

	return useQuery({
		queryKey: [
			"attendance",
			"team",
			activeCanteiroId,
			range.from,
			range.to,
			workerId,
		],
		enabled: enabled && activeCanteiroId != null && workerId != null,
		queryFn: async (): Promise<AttendanceWorkerDays | undefined> => {
			const { items } = await listAttendanceDays(activeCanteiroId as string, {
				from: range.from,
				to: range.to,
				workerId,
			});
			return items.map(toAttendanceWorkerDays)[0];
		},
		staleTime: 30_000,
	});
}
